<template>
  <ab-test-wrapper css-class="ab-test-inline-life-stage show-a">
    <template #component_a>
      <MoleculesInlineLifeStage v-bind="props" />
    </template>

    <template #component_b>
      <MoleculesInlineLifeStage
        v-bind="props"
        theme="v2"
      />
    </template>
  </ab-test-wrapper>
</template>
<script setup>
defineOptions({
  name: 'OrganismsInlineLifeStageAbTest'
})

const props = defineProps({
  ctaId: {
    type: String,
    default: 'inline-card-cta'
  },

  ctaClass: {
    type: String,
    default: ''
  },

  componentVertical: {
    type: String,
    default: 'Home Loans'
  },

  customComponent: {
    type: Object,
    default: () => ({})
  },

  title: {
    type: String,
    default: 'Select your state and compare now!'
  },

  subtitle: {
    type: String,
    default: 'Discover the best options for you'
  },

  redirectUrl: {
    type: String,
    default: '/home-loans/quote/form/step1/'
  },

  ctaType: {
    type: String,
    default: 'State'
  }
})
</script>
